import _ from 'lodash';

// function that will format query string to be
// &taxonomy=type
export const FormatFiltersQuery = (selectedFilters) => {
	if (_.isEmpty(selectedFilters)) return '';

	let filtersQuery = '&';
	
	for (const key in selectedFilters) {
		filtersQuery += `${key}=${selectedFilters[key]}`
	}

	return filtersQuery;
};

export default FormatFiltersQuery;